import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { assetsForm, divisionsForm, tagsForm } from './filterForm';
import * as assetActions from '../../../core/asset/assetActions';

class TheFilterForm extends React.Component {
    constructor(props) {
        super(props);

        switch (this.props.type) {
            case 'asset':
                this.view = assetsForm;
                break;
            case 'division':
                this.view = divisionsForm;
                break;
            case 'tag':
                this.view = tagsForm;
                break;
            default:
                this.view = assetsForm;
                break;
        }
    }

    componentDidMount() {
        const {
            actions,
        } = this.props;
        actions.getAssetOptionsRequest();
        actions.getVehicleMakesRequest();
        actions.getAllAssetOptionsRequest();
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll(['asset', 'make', 'fuel_type', 'divisions', 'vehicle_type', 'tags', 'tag_ids'], (err, values) => {
            if (!err) {
                const { onSubmit } = this.props;
                onSubmit(values);
            }
        });
    };

    render() {
        return this.view();
    }
}

TheFilterForm.defaultProps = {
    type: 'asset',
};

TheFilterForm.propTypes = {
    form: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    type: PropTypes.string,
    divisions: PropTypes.array.isRequired,
    searchParams: PropTypes.object.isRequired,
};

const FilterForm = Form.create({
    name: 'assetsFilterForm',
    mapPropsToFields() {},
})(TheFilterForm);

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps,
        divisions: state.asset.divisions,
        tags: state.companyTags.tagList,
        vehicleTypes: state.asset.vehicleTypes,
        vehicleMakes: state.asset.vehicleMakes,
        searchParams: state.asset.assetSearchParams,
        assetOptions: state.asset.allOptions,
        assetTabFilters: state.filters.assetTabFilters,
        divisionTabFilters: state.filters.divisionTabFilters,
        tagsTabFilters: state.filters.tagsTabFilters,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...assetActions,
        }, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(FilterForm);
